import { OnboardingAcknowledgement } from '../types/use-acknowledge-onboarding-step-enums';
import type { AccountOnboarding } from '@adtrackify/at-tracking-event-types';

const ACKNOWLEDGEMENT_TIMESTAMP_MAP: Record<
  OnboardingAcknowledgement,
  keyof AccountOnboarding
> = {
  [OnboardingAcknowledgement.TRACKING_INSTALLED]: 'trackingInstalledAt',
  [OnboardingAcknowledgement.SHOPIFY_DATA_SHARING_DISABLED]: 'shopifyDataSharingDisabledAt',
  [OnboardingAcknowledgement.KLAVIYO_FLOWS_CONFIGURED]: 'klaviyoFlowsConfiguredAt',
};

export { ACKNOWLEDGEMENT_TIMESTAMP_MAP };
